var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _g3, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIconMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 41,
    viewBox: "0 0 75 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6266 0H27.2081V40.9998H26.0257C24.9702 40.9956 23.9592 40.5829 23.2129 39.8517C22.4666 39.1206 22.0454 38.1301 22.041 37.0961V2.53309C22.0425 1.86171 22.3154 1.21824 22.7999 0.743503C23.2845 0.268766 23.9413 0.00142847 24.6266 0Z",
    fill: "#7AB30E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1128_31420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 0,
    width: 6,
    height: 41
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6266 0H27.2081V40.9998H26.0257C24.9702 40.9956 23.9592 40.5829 23.2129 39.8517C22.4666 39.1206 22.0454 38.1301 22.041 37.0961V2.53309C22.0425 1.86171 22.3154 1.21824 22.7999 0.743503C23.2845 0.268766 23.9413 0.00142847 24.6266 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1128_31420)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1128_31420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5065 7.62408C14.7241 7.62408 10.0371 12.1726 10.0371 17.7889C10.0371 23.4052 14.7282 27.955 20.5065 27.955C26.2849 27.955 30.9746 23.4012 30.9746 17.7889C30.9746 12.1766 26.2835 7.62408 20.5065 7.62408Z",
    fill: "#147F26"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8354 7.87005H60.0199C59.0266 7.87424 58.069 8.23369 57.3271 8.88085C56.5852 9.52801 56.1101 10.4183 55.9911 11.3845H50.8047C50.9296 9.07136 51.9545 6.89306 53.6685 5.29755C55.3826 3.70204 57.6556 2.8106 60.0199 2.80658H75.0011V17.4861C74.9957 19.8809 74.0221 22.1762 72.2936 23.8697C70.565 25.5631 68.2221 26.5168 65.7776 26.5222H58.2042V25.3651C58.2064 24.3305 58.6269 23.3388 59.3737 22.6072C60.1205 21.8755 61.1328 21.4636 62.1889 21.4614H65.7762C66.8508 21.4564 67.88 21.036 68.6399 20.2916C69.3998 19.5471 69.8289 18.5389 69.834 17.4861V7.87005H69.8354Z",
    fill: "#7AB30E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1128_31420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 2,
    width: 26,
    height: 25
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8354 7.87005H60.0199C59.0266 7.87424 58.069 8.23369 57.3271 8.88085C56.5852 9.52801 56.1101 10.4183 55.9911 11.3845H50.8047C50.9296 9.07136 51.9545 6.89306 53.6685 5.29755C55.3826 3.70204 57.6556 2.8106 60.0199 2.80658H75.0011V17.4861C74.9957 19.8809 74.0221 22.1762 72.2936 23.8697C70.565 25.5631 68.2221 26.5168 65.7776 26.5222H58.2042V25.3651C58.2064 24.3305 58.6269 23.3388 59.3737 22.6072C60.1205 21.8755 61.1328 21.4636 62.1889 21.4614H65.7762C66.8508 21.4564 67.88 21.036 68.6399 20.2916C69.3998 19.5471 69.8289 18.5389 69.834 17.4861V7.87005H69.8354Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1128_31420)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1128_31420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2942 -3.41541C44.7228 -3.41541 42.2092 -2.66839 40.0711 -1.26882C37.9331 0.13075 36.2667 2.12001 35.2826 4.44741C34.2986 6.77481 34.0411 9.33581 34.5428 11.8066C35.0444 14.2773 36.2827 16.5469 38.101 18.3282C39.9192 20.1095 42.2358 21.3226 44.7578 21.814C47.2798 22.3055 49.8939 22.0533 52.2696 21.0892C54.6453 20.1252 56.6758 18.4926 58.1044 16.398C59.533 14.3034 60.2955 11.8408 60.2955 9.32168C60.2955 7.64902 59.9592 5.99275 59.3058 4.44741C58.6524 2.90208 57.6948 1.49795 56.4875 0.315202C55.2802 -0.867547 53.847 -1.80575 52.2696 -2.44585C50.6922 -3.08595 49.0016 -3.41541 47.2942 -3.41541Z",
    fill: "#147F26"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1128_31420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1687 14.4261C49.3862 14.4261 44.6992 18.98 44.6992 24.5923C44.6992 30.2046 49.3903 34.7584 55.1687 34.7584C60.947 34.7584 65.6367 30.2086 65.6367 24.5923C65.6367 18.976 60.9498 14.4261 55.1687 14.4261Z",
    fill: "#147F26"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7364 0C49.1128 0.00530988 51.3958 0.907004 53.1115 2.51789C54.8272 4.12877 55.8438 6.32509 55.9502 8.65089H55.9599V40.9998H54.7857C53.73 40.9959 52.7187 40.5834 51.9721 39.8522C51.2254 39.121 50.804 38.1304 50.7997 37.0961V9.04153C50.7946 7.98847 50.3658 6.97985 49.6064 6.23458C48.847 5.4893 47.8181 5.06752 46.7433 5.06077H36.9154V14.6768C36.9208 15.7309 37.3507 16.7403 38.1115 17.4857C38.8724 18.2311 39.9027 18.6522 40.9787 18.6575H44.595C45.65 18.6625 46.6603 19.0755 47.406 19.8066C48.1517 20.5377 48.5726 21.5277 48.5769 22.5613V23.7183H40.9746C38.5289 23.7115 36.1853 22.7568 34.4558 21.0627C32.7263 19.3686 31.7514 17.0728 31.7441 14.6768V0H46.7364Z",
    fill: "#7AB30E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0413 5.06077H9.22492C8.14944 5.06611 7.11966 5.4874 6.35969 6.23294C5.59972 6.97847 5.1711 7.98791 5.16711 9.04154V23.7183H0V9.04154C0.00401008 6.64548 0.977074 4.34863 2.70609 2.65398C4.43511 0.959327 6.77917 0.00500347 9.22492 0H27.2084V14.6768C27.206 16.375 26.7162 18.0384 25.795 19.4771C24.8738 20.9157 23.5582 22.0715 21.9985 22.8127V15.2702C22.0277 15.0737 22.042 14.8753 22.0413 14.6768V5.06077ZM21.9985 22.8127C20.7477 23.4092 19.3746 23.7189 17.9835 23.7183H7.37883V22.5613C7.38065 21.5262 7.80124 20.5342 8.54842 19.8024C9.29559 19.0707 10.3084 18.659 11.3649 18.6575H17.9876C18.9587 18.653 19.8964 18.3095 20.6323 17.6887C21.3681 17.0678 21.854 16.2104 22.0027 15.2702V22.8127H21.9985Z",
    fill: "#7AB30E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1128_31420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 24
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0413 5.06077H9.22492C8.14944 5.06611 7.11966 5.4874 6.35969 6.23294C5.59972 6.97847 5.1711 7.98791 5.16711 9.04154V23.7183H0V9.04154C0.00401008 6.64548 0.977074 4.34863 2.70609 2.65398C4.43511 0.959327 6.77917 0.00500347 9.22492 0H27.2084V14.6768C27.206 16.375 26.7162 18.0384 25.795 19.4771C24.8738 20.9157 23.5582 22.0715 21.9985 22.8127V15.2702C22.0277 15.0737 22.042 14.8753 22.0413 14.6768V5.06077ZM21.9985 22.8127C20.7477 23.4092 19.3746 23.7189 17.9835 23.7183H7.37883V22.5613C7.38065 21.5262 7.80124 20.5342 8.54842 19.8024C9.29559 19.0707 10.3084 18.659 11.3649 18.6575H17.9876C18.9587 18.653 19.8964 18.3095 20.6323 17.6887C21.3681 17.0678 21.854 16.2104 22.0027 15.2702V22.8127H21.9985Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1128_31420)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1128_31420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48311 16.0153C0.700636 16.0153 -3.98633 20.5692 -3.98633 26.1815C-3.98633 31.7937 0.704775 36.3463 6.48311 36.3463C12.2614 36.3463 16.9512 31.7978 16.9512 26.1815C16.9512 20.5651 12.2601 16.0153 6.48311 16.0153Z",
    fill: "#147F26"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.7732H5.16711V41H3.98468C2.92922 40.9957 1.91823 40.5831 1.1719 39.8519C0.425572 39.1207 0.00435846 38.1303 0 37.0963V10.7732Z",
    fill: "#7AB30E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1128_31420",
    x: 5.03711,
    y: 2.62408,
    width: 30.9375,
    height: 30.331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1128_31420"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1128_31420",
    x: 29.293,
    y: -8.41541,
    width: 36.002,
    height: 35.4742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1128_31420"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1128_31420",
    x: 39.6992,
    y: 9.42615,
    width: 30.9375,
    height: 30.3323,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1128_31420"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1128_31420",
    x: -8.98633,
    y: 11.0153,
    width: 30.9375,
    height: 30.331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1128_31420"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconMini);
export default __webpack_public_path__ + "static/media/app_icon_mini.de18ee296f07386ea6c676a23951de7a.svg";
export { ForwardRef as ReactComponent };